import React from 'react'

function AddStudentResultForm({studentId,masters}) {
  	return (
		<div>AddStudentResultForm</div>
  	)
}

export default AddStudentResultForm